export default __webpack_public_path__ + "static/cloudicon3-468c545103872cf45511b363a5bff487.webp";